import styled from "styled-components";

export const StyledDiv = styled.div`
  padding-right: 5px;
  cursor: pointer;
`;
